/** A Laravel paginator page: what infinite queries page through. */
export interface IPaginatedPage<T> {
  current_page: number;
  last_page: number;
  data: T[];
}

export const paginationService = {
  /** Next page number, or undefined once the last page is loaded (TanStack stops there). */
  nextPage(
    lastPage:
      Pick<IPaginatedPage<unknown>, "current_page" | "last_page"> | undefined,
  ) {
    return lastPage && lastPage.current_page < lastPage.last_page
      ? lastPage.current_page + 1
      : undefined;
  },

  /** Every loaded row in order; a page without a data array contributes nothing. */
  flatten<T>(
    pages: (Partial<IPaginatedPage<T>> | undefined)[] | undefined,
  ): T[] {
    return (pages ?? []).flatMap((page) =>
      Array.isArray(page?.data) ? page.data : [],
    );
  },
};
